import { useState, useEffect } from 'react';
import { RefreshCw, ShieldCheck, Tag, Handshake, UserPlus, Wallet } from 'lucide-react';

const ACTIVITIES = [
  { icon: Tag, iconColor: 'text-blue-400', text: 'Juan de El Pedregal publico una Bicicleta en $1,200 MXN' },
  { icon: Handshake, iconColor: 'text-emerald-400', text: 'Ana G. de Benevento concreto una compra' },
  { icon: ShieldCheck, iconColor: 'text-cyan-400', text: 'Pedro de Cholula verifico su identidad' },
  { icon: Tag, iconColor: 'text-blue-400', text: 'Maria L. de Santa Maria publico un servicio de reposteria' },
  { icon: RefreshCw, iconColor: 'text-orange-400', text: 'Carlos de Coapanoaya publico una moto en $18,000 MXN' },
  { icon: Handshake, iconColor: 'text-emerald-400', text: 'Sofia R. de San Antonio hizo una oferta por un iPhone' },
  { icon: UserPlus, iconColor: 'text-violet-400', text: 'Diego de San Miguel acaba de registrarse en Bisne' },
  { icon: Tag, iconColor: 'text-blue-400', text: 'Lupita de Ocoyoacac publico un Menu del dia en $80 MXN' },
  { icon: RefreshCw, iconColor: 'text-orange-400', text: 'Roberto de Toluca Norte concreto un intercambio' },
  { icon: Wallet, iconColor: 'text-amber-400', text: 'Valeria de Tepexoyuca abrio su Boveda de Bienvenida' },
];

export default function ActivityFeed() {
  const [index, setIndex] = useState(() => Math.floor(Math.random() * ACTIVITIES.length));
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIndex(prev => (prev + 1) % ACTIVITIES.length);
        setFade(true);
      }, 300);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const activity = ACTIVITIES[index];
  const Icon = activity.icon;

  return (
    <div data-testid="activity-feed" className="mx-3 mb-1.5">
      <div className="flex items-center gap-2 bg-zinc-900/70 rounded-lg px-3 py-2 min-h-[32px]">
        {/* Pulsing green dot */}
        <span className="relative shrink-0 flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" />
        </span>
        {/* Icon */}
        <Icon className={`w-3.5 h-3.5 shrink-0 ${activity.iconColor}`} />
        {/* Text */}
        <p
          data-testid="activity-feed-text"
          className={`flex-1 text-zinc-400 font-body text-[11px] leading-snug truncate transition-opacity duration-300 ${fade ? 'opacity-100' : 'opacity-0'}`}
        >
          {activity.text}
        </p>
      </div>
    </div>
  );
}
